const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '暴走黑料 · 七月娱乐圈大地震全记录',
    heat: '12.6万',
    change: 'up',
    changeNum: '+3',
    tag: '暴走黑料',
  },
  {
    id: 2,
    rank: 2,
    title: '黑料社精选 · 顶流艺人商业版图起底',
    heat: '9.8万',
    change: 'up',
    changeNum: '+1',
    tag: '黑料社',
  },
  {
    id: 3,
    rank: 3,
    title: '综艺录制冲突完整版 · 多方说法全对比',
    heat: '8.5万',
    change: 'down',
    changeNum: '-1',
    tag: '综艺深扒',
  },
  {
    id: 4,
    rank: 4,
    title: '网红合约纠纷内幕 · 涉及十位头部主播',
    heat: '7.2万',
    change: 'up',
    changeNum: '+5',
    tag: '网红观察',
  },
  {
    id: 5,
    rank: 5,
    title: '代言翻车实录 · 下半年品牌危机大盘点',
    heat: '6.3万',
    change: 'down',
    changeNum: '-2',
    tag: '深扒专题',
  },
  {
    id: 6,
    rank: 6,
    title: '艺人片酬排行榜 · 真实数据首次公开对比',
    heat: '5.8万',
    change: 'new',
    changeNum: '新',
    tag: '暴走黑料',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            本周暴走黑料与黑料社内容热度排行榜
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 px-5 py-4 border-b border-background-200/40 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer group"
              >
                <div className="flex-shrink-0 w-8 text-center">
                  {item.rank <= 3 ? (
                    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-sm font-bold ${
                      item.rank === 1 ? 'bg-primary-500 text-background-50' :
                      item.rank === 2 ? 'bg-accent-500/20 text-accent-500' :
                      'bg-secondary-500/20 text-secondary-500'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500/10 text-primary-400 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                  </div>
                </div>

                <div className="flex-shrink-0 flex items-center gap-1 text-xs">
                  <span className={`${
                    item.change === 'up' ? 'text-accent-500' :
                    item.change === 'down' ? 'text-secondary-500' :
                    'text-primary-500'
                  } font-semibold`}>
                    {item.changeNum}
                  </span>
                  {item.change !== 'new' && (
                    <i className={`text-xs ${
                      item.change === 'up' ? 'ri-arrow-up-line text-accent-500' :
                      'ri-arrow-down-line text-secondary-500'
                    }`}></i>
                  )}
                </div>

                <div className="flex-shrink-0 w-16 text-right">
                  <span className="text-xs font-semibold text-foreground-600">{item.heat}</span>
                  <span className="text-[10px] text-foreground-400 ml-0.5">热度</span>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <span className="inline-flex items-center gap-1.5 text-sm text-primary-500 cursor-pointer hover:underline whitespace-nowrap">
              查看完整排行榜 <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}